import generalReducer from './generalReducer';

export * from './generalActions';
export default generalReducer;
